import headphones from "assets/img/headphones.svg";
import loaderTitleEn from "assets/img/loader-title-en.png";
import loaderTitle from "assets/img/loader-title.png";
import i18next from "i18next";
import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../assets/scss/Views/welcome.scss";
import VideoJS from "../Components/VideoPlayer/VideoJS";
// import InteractiveContext from "context/InteractiveContext";
const IntroMobile = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
}) => {
  const { t } = useTranslation();
  const playerRef = useRef(null);
  const { resolvedLanguage } = i18next;

  useEffect(() => {
    setPageTitle("");
    setShowMenuToggler(false);
    setIsBackgroundMusic(false);
  }, [setPageTitle, setShowMenuToggler, setIsBackgroundMusic]);

  useEffect(() => {
    if (!playerRef.current) return;
    // remove old text tracks
    playerRef?.current
      ?.remoteTextTracks()
      .tracks_.forEach((track) =>
        playerRef.current.removeRemoteTextTrack(track)
      );

    if (resolvedLanguage !== "en") return;
    // add text track to current video
    playerRef?.current?.addRemoteTextTrack(
      {
        kind: "captions",
        src: "/subtitles/Intro_eng.vtt",
        mode: "showing",
        default: true,
        srcLang: "en",
        label: "en",
        language: "en",
      },
      true
    );
  }, [playerRef, resolvedLanguage]);

  const videoJsOptions = useMemo(() => {
    return {
      controls: false,
      fluid: true,
      autoplay: true,
      loop: true,
      sources: "/videos/intro.mp4",
    };
  }, []);

  const onPlayerReadyHandler = (player) => {
    playerRef.current = player;
    playerRef.current.play();
    if (resolvedLanguage !== "en") return;
    // add text track to current video
    playerRef?.current?.addRemoteTextTrack(
      {
        kind: "captions",
        src: "/subtitles/Intro_eng.vtt",
        mode: "showing",
        default: true,
        srcLang: "en",
        label: "en",
        language: "en",
      },
      true
    );
  };

  return (
    <div>
      <div className="position-absolute bottom-0 w-100 d-flex justify-content-center align-items-center flex-column  pb-5 mb-2 z-index-11 top-0">
        <div className="p-3">
          <img
            src={
              i18next.resolvedLanguage === "pl" ? loaderTitle : loaderTitleEn
            }
            alt=""
            className="w-100"
          />
        </div>
        <div className="p-3">
          <img src={headphones} alt="" className="m-3" />
        </div>
        <div className="p-3 text-center">
          <p>{t("mobileIntro1")}</p>
          <p>{t("mobileIntro2")}</p>
        </div>
      </div>
      <VideoJS options={videoJsOptions} onPlayerReady={onPlayerReadyHandler} />
    </div>
  );
};

export default IntroMobile;
